import { Flex, Box } from './layouts';
import { useTheme } from '@emotion/react';
import { useMediaQuery } from '@dnhb/node_package';
import TextWithLinks from './TextWithLinks';
import {FC} from "react";

interface Props {
  label: string;
  value: string | string[] | number;
  textArea?: boolean;
  linkify?: boolean;
}

const DisplayLine: FC<Props> = ({ label, value, textArea, linkify }) => {
  const { breakpoints } = useTheme();
  const isMinDesktop = useMediaQuery(
    `(min-width: ${breakpoints.ml ?? '56.25rem'})`
  );
  const mobileException = !isMinDesktop && textArea;
  const shouldRender = value?.constructor === Array ? value.length > 0 : value;
  const formatValue = (value) =>
    linkify ? <TextWithLinks>{value}</TextWithLinks> : value;

  return shouldRender ? (
    <Flex flexWrap={mobileException ? 'wrap' : 'initial'}>
      <Box
        m={mobileException && '8px 0'}
        pr="4px"
        minWidth={{ mobile: '152px', tablet: '208px' }}
        width={'100%'}
        maxWidth={!mobileException && { mobile: '50%', tablet: '40%' }}
        flexShrink={0}
        fontWeight="bold"
        css={{ overflowWrap: 'break-word', hyphens: 'auto' }}
      >
        {label}
      </Box>
      <Box
        flexBasis={mobileException && '100%'}
        flexGrow={1}
        css={{
          overflowWrap: 'anywhere',
          ':first-letter': { textTransform: !linkify ? 'uppercase' : null },
        }}
      >
        {value?.constructor === Array
          ? value.map((line) => <div key={line}>{formatValue(line)}</div>)
          : formatValue(value)}
      </Box>
    </Flex>
  ) : null;
};

export default DisplayLine;
